import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VersionClient } from '../api/WickedApiClient';

@Injectable({
  providedIn: "root"
})
export class VersionCheckService {
  private VersionHashKey = "Version";
  private frequencyCheck = 30000;

  public versionChanged: EventEmitter<boolean> = new EventEmitter();

  get CurrentHash(): string {
    return localStorage.getItem(this.VersionHashKey) ? localStorage.getItem(this.VersionHashKey) : "";
  }

  set CurrentHash(hash: string) {
    localStorage.setItem(this.VersionHashKey, hash);
  }

  constructor(private versionClient: VersionClient) {
    this.clearVersion();
    this.initVersionCheck();
    this.checkVersion();
  }

  public initVersionCheck() {
    setInterval(() => {
      this.checkVersion();
    }, this.frequencyCheck);
  }

  clearVersion() {
    localStorage.removeItem(this.VersionHashKey);
  }

  private checkVersion() {
    this.versionClient.versionHash(new Date().getTime().toString()).subscribe(hash => {
      if (!this.CurrentHash || this.CurrentHash == "") {
        this.CurrentHash = hash;
      } else {
        if (this.hasHashChanged(this.CurrentHash, hash)) {
          this.versionChanged.emit(true);
          this.CurrentHash = hash;
        }
      }
    });
  }

  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || !newHash || currentHash == "" || newHash == "") {
      return false;
    }

    if (!newHash) {
      return false;
    }

    return currentHash !== newHash;
  }
}
